import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { hairStyles } from '../mock';

const HairStyles = ({ t, lang }) => {
  return (
    <section id="styles" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.styles.title}
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            {t.styles.subtitle}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mt-6"></div>
        </div>

        {/* Styles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {hairStyles.map((style) => (
            <Card
              key={style.id}
              className="bg-gray-900 border-gray-800 hover:border-amber-500/50 transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={style.image}
                  alt={style.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                {style.popularity === 'high' && (
                  <Badge className="absolute top-4 right-4 bg-amber-500 text-black border-0">
                    Popular
                  </Badge>
                )}
              </div>
              <CardHeader>
                <CardTitle className="text-white text-xl">{style.name}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-gray-400">
                  {style.description[lang]}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HairStyles;
